var map = {
	"./agaloola/assets/static/icons/rubicons/ag-location-pin.svg": 82829,
	"./agaloola/assets/static/icons/rubicons/ag-mail.svg": 15167,
	"./agaloola/assets/static/icons/rubicons/ag-phone.svg": 42018,
	"./agaloola/assets/static/icons/rubicons/ag-star.svg": 38338,
	"./agaloola/assets/static/icons/rubicons/coffee-cup.svg": 89618
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35121;